import React from 'react';
import { observer } from 'mobx-react-lite';

import Icon from '../../Icon';

import { Orderedlist, BreadcrumbList, ItemList } from './Styles';

const BreadcrumbItem = ({ children, ...props }) => (
  <ItemList {...props}>{children}</ItemList>
);

const BreadcrumbSeparator = ({ children, ...props }) => (
  <BreadcrumbList {...props}>{children}</BreadcrumbList>
);

const BreadcrumbContainer = (props) => {
  let children = React.Children.toArray(props.children);

  children = children.map((child, index) => (
    <BreadcrumbItem key={`breadcrumb_item${index}`}>{child}</BreadcrumbItem>
  ));

  const lastIndex = children.length - 1;

  children = children.reduce((acc, child, index) => {
    const notLast = index < lastIndex;
    if (notLast) {
      acc.push(
        child,
        <BreadcrumbSeparator key={`breadcrumb_sep${index}`}>
          <Icon icon="angle-right" size={1.2} />
        </BreadcrumbSeparator>,
      );
    } else {
      acc.push(child);
    }
    return acc;
  }, []);

  return <Orderedlist data-testid="breadcrumb-list">{children}</Orderedlist>;
};

export default observer(BreadcrumbContainer);
